var usd_formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export function fmtCurrency(x) {
  if(typeof x !== 'undefined') {
    try {
      return usd_formatter.format(x);
    } catch {}
  }
  return "";
}

export function fmtCurrencyConcise(x) {
  if(typeof x !== 'undefined') {
    try {
      return '$'+fmtDecimalConcise(x,1,true,true);
    } catch {}
  }
  return "";
}

export function fmtDecimalConcise(x, decimals = 2, signed=true, truncate_zeros=false) {
    if (typeof x !== 'undefined' && x !== null) {
        if (x === 0) return (decimals>0&&!truncate_zeros)?`0.${Array(decimals+1).join('0')}`:'0';
        const unsignedX=Math.abs(x);
        const k = 1000;
        const sizes = ['', 'K', 'M', 'B', 'T'];
        const i = Math.max(Math.floor(Math.log(unsignedX) / Math.log(k)),0);
        const sign=signed?(x<0?"-":""):"";
        let value=unsignedX / Math.pow(k, i);
        value=value.toFixed(decimals < 0 || value>=10 ? 0 : decimals);
        value=truncate_zeros?parseFloat(value):value;
        return `${sign}${value}${sizes[i]}`;
    } else {
        return "";
    }
}


export function fmtBigInteger(x) {
  if(typeof x !== 'undefined') {
    try {
      if(Number.isFinite(x)) {
        x=Math.round(x);
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } catch {}
  }
  return "";
}

export function fmtSign(value) {
  if (value<0) {
    return "-";
  } else if (value>0) {
    return "+";
  } else {
    return "";
  }
}

export function getPercent(numerator, denominator) {
  let result=0;
  if (denominator) {
    result=(Math.abs(numerator)/denominator) * 100;
    result=Math.min(result,100);
    result=Math.max(result,0);
  }
  return result;
}

export function fmtPercent(numerator, denominator, precision=0) {
  return (getPercent(numerator,denominator).toFixed(precision) + "%");
}

// export function fmtPercent(n,d) {
//     if(d===0) {
//       return "0%";
//     } else {
//       let pct=Math.floor((Math.abs(n)/d)*100);
//       return (pct===0?"<1":pct)+"%";
//     }
// }

var ranges = [
  { divider: 1e18 , suffix: 'E' },
  { divider: 1e15 , suffix: 'P' },
  { divider: 1e12 , suffix: 'T' },
  { divider: 1e9 , suffix: 'G' },
  { divider: 1e6 , suffix: 'M' },
  { divider: 1e3 , suffix: 'K' }
];

export function fmtMetricInteger(n) {
  for (var i = 0; i < ranges.length; i++) {
    if (n >= ranges[i].divider) {
      return Math.round((n / ranges[i].divider)).toString() + ranges[i].suffix;
    }
  }
  return n.toString();
}

